import type { SliceComponentType } from "@commercekit/prismic";
import { SliceZoneC } from "@commercekit/prismic";
import { useLoaderData } from "@remix-run/react";
import type { SerializeFrom } from "@remix-run/node";
import { components } from "~/lib/prismic";
import { metaHelper } from "~/lib/meta";

import { loader, action } from "~/routes-server/contact.server";
export { default as ErrorBoundary } from "~/components/atoms/GeneralErrorBoundary";
export type { headers } from "@commercekit/remix/lib/headers.server";
export { loader, action };

export const meta = ({ data }: { data?: SerializeFrom<typeof loader> }) => {
  const base = metaHelper({ data }) ?? [];
  const schemas = [];
  if (data?.contactPageSchema != null) schemas.push({ "script:ld+json": data.contactPageSchema } as const);
  if (data?.organizationSchema != null) schemas.push({ "script:ld+json": data.organizationSchema } as const);
  return [...base, ...schemas];
};

const ContactPage = () => {
  const { contact } = useLoaderData<typeof loader>();

  return (
    <div>
      <SliceZoneC
        slices={contact?.data?.slices}
        components={components as Record<string, SliceComponentType>}
        defaultComponent={({ slice }) => (
          <div className="hidden">{slice.slice_type}</div>
        )}
      />
    </div>
  );
};
export default ContactPage;
